import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import { isNil } from 'lodash-es';
import { DateTime } from 'luxon';
import { CommonModule } from '@angular/common';

class LocalStorageService {
    setItem(key, value, expiration = null) {
        if (!key || isNil(value)) {
            return;
        }
        if (expiration) {
            const item = {
                expiresIn: expiration && expiration.duration
                    ? DateTime.now().plus(expiration.duration).toISO()
                    : null,
                data: value,
            };
            return localStorage.setItem(key, JSON.stringify(item));
        }
        localStorage.setItem(key, typeof value !== 'object' ? value : JSON.stringify(value));
    }
    getItem(key, parse) {
        const storedString = localStorage.getItem(key);
        if (!storedString) {
            return null;
        }
        let parsedItem;
        try {
            parsedItem = JSON.parse(storedString);
        }
        catch (e) {
            parsedItem = storedString;
        }
        if (typeof parsedItem === 'object') {
            if (parsedItem?.expiresIn &&
                parsedItem?.data &&
                DateTime.now() > DateTime.fromISO(parsedItem.expiresIn)) {
                localStorage.removeItem(key);
                return null;
            }
            return !parse && !parsedItem?.expiresIn
                ? storedString
                : parsedItem?.data || parsedItem;
        }
        return parse ? parsedItem : storedString || null;
    }
    key(index) {
        return localStorage.key(index);
    }
    clear() {
        localStorage.clear();
    }
    removeItem(key) {
        localStorage.removeItem(key);
    }
}
LocalStorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocalStorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LocalStorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocalStorageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: LocalStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class SessionStorageService {
    setItem(key, value, expiration = null) {
        if (!key || isNil(value)) {
            return;
        }
        if (expiration) {
            const item = {
                expiresIn: expiration && expiration.duration
                    ? DateTime.now().plus(expiration.duration).toISO()
                    : null,
                data: value,
            };
            return sessionStorage.setItem(key, JSON.stringify(item));
        }
        sessionStorage.setItem(key, typeof value !== 'object' ? value : JSON.stringify(value));
    }
    getItem(key, parse) {
        const storedString = sessionStorage.getItem(key);
        if (!storedString) {
            return null;
        }
        let parsedItem;
        try {
            parsedItem = JSON.parse(storedString);
        }
        catch (e) {
            parsedItem = storedString;
        }
        if (typeof parsedItem === 'object') {
            if (parsedItem?.expiresIn &&
                parsedItem?.data &&
                DateTime.now() > DateTime.fromISO(parsedItem.expiresIn)) {
                sessionStorage.removeItem(key);
                return null;
            }
            return !parse && !parsedItem?.expiresIn
                ? storedString
                : parsedItem?.data || parsedItem;
        }
        return parse ? parsedItem : storedString || null;
    }
    key(index) {
        return sessionStorage.key(index);
    }
    clear() {
        sessionStorage.clear();
    }
    removeItem(key) {
        sessionStorage.removeItem(key);
    }
}
SessionStorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SessionStorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SessionStorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SessionStorageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: SessionStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class StorageModule {
}
StorageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: StorageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StorageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: StorageModule, imports: [CommonModule] });
StorageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: StorageModule, providers: [LocalStorageService, SessionStorageService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: StorageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [LocalStorageService, SessionStorageService]
                }]
        }] });

export { LocalStorageService, SessionStorageService, StorageModule };
